import React, { ReactNode, useEffect } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import styled from 'styled-components'
import CreationToolError from '../../../types/error'
import { OverlayBlock } from '../../blocks'
import ErrorModal from '../../error-modal'

const Container = styled.div`
    height: 100%;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 500;
`

const Dim = styled(OverlayBlock)`
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
`

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 100%;
    width: 100%;
`

const Modal = styled.div`
    margin: 50px auto;
    position: relative;
`

const Loader = styled.div`
    align-items: center;
    background: inherit;
    border-radius: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10;
`

type Props = {
    children?: ReactNode
    className?: string
    error?: CreationToolError
    isLoading?: boolean
    onClose: () => void
    goBackLabel?: string
}

const CreationToolsBaseSuperCutModal = ({
    children,
    className,
    error,
    isLoading = false,
    onClose,
    goBackLabel = 'Cancel',
}: Props) => {
    useEffect(() => {
        // disable body scrolling
        document.body.style.overflow = 'hidden'

        return () => {
            // re-enable body scrolling
            document.body.style.overflow = ''
        }
    }, [])

    return (
        <Container>
            <Wrapper>
                <Dim onClick={onClose} />
                <Modal className={className} style={error ? { display: 'none' } : {}}>
                    {children}
                    {isLoading && (
                        <Loader>
                            <DotsLoader />
                        </Loader>
                    )}
                </Modal>
                {error && (
                    <ErrorModal
                        {...{
                            error,
                            goBackLabel: goBackLabel,
                            onGoBack: onClose,
                        }}
                    />
                )}
            </Wrapper>
        </Container>
    )
}

export default CreationToolsBaseSuperCutModal
